
export const serviceBasePath = 

process.env.NODE_ENV === "development"?
"https://localhost:5029":
"https://erich.azurewebsites.net"
;